import { useEffect } from 'react';
import { useLogout } from '@/apis/auth/hook';
import { Navigate, useLocation } from 'react-router-dom';
import { auth } from '@/routes/config';
import { getCookie } from '@/utils/helperFunctions';
import { CacheKeys } from '@/utils/cacheKeys';

export default function Logout() {
  const location = useLocation();
  const isAuthenticated = getCookie(CacheKeys.isAuthenticated) === 'true';
  const { mutate: doLogout } = useLogout();
  useEffect(() => {
    if (isAuthenticated) doLogout();
  }, [doLogout, isAuthenticated]);
  return <Navigate to={`${auth.base}/${auth.login}`} state={location.state} replace />;
}
